
import { debounce } from '@/utils'

export default {
  name: 'BargainDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    goodsNo: {
      type: String,
      required: false,
      default: ''
    },
    goodsPrice: {
      type: Number,
      required: false,
      default: 0
    },
    bargainCheck: {
      type: Object,
      default: () => ({})
    },
    userInfo: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    share:{
        type:Boolean,
        default:false
    }
  },
  data() {
    return {
      price: '',
      serviceFee: 0,
      isCheckingServiceFee: false,
      showTouchTip: true,
      bgImage: 'https://oss.pzds.com/mobileV3/20250625134653454.png',
      sliderVal: 0, // 独立的滑块值，不与输入框双向绑定
      isInitializing: false // 标记是否在初始化过程中
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    },
    // 商品原价
    originPrice() {
      return this.share ? Math.floor(this.bargainCheck?.goodsPrice || 0) : Math.floor(this.goodsPrice || 0)
    },
    // 最低出价价格
    minBargainPrice() {
      const baseMinPrice = Math.ceil(this.bargainCheck?.goodsPriceRate * this.bargainCheck?.goodsPrice / 100 || 0);
      return Math.max(baseMinPrice, this.serviceFee);
    },
    // 砍价成功率
    successRate() {
      if (!this.price || +this.price > this.originPrice)
        return ''
      // 出价 ≥ 原价*85% → 高
      if (+this.price >= this.originPrice * 0.85)
        return '高'
      // 原价*75% ≤ 出价 < 原价*85% → 中
      else if (+this.price >= this.originPrice * 0.75)
        return '中'
      // 原价*65% ≤ 出价 < 原价*75% → 低
      else if (+this.price >= this.minBargainPrice)
        return '低'
      else return ''
    },
    // 砍价成功率图标
    successRateIcon() {
      const iconMap = {
        '高': 'https://oss.pzds.com/mobileV3/icon-high%402x.png',
        '低': 'https://oss.pzds.com/mobileV3/icon-lower%402x.png'
      }
      return this.successRate ? iconMap[this.successRate] : ''
    },
    // 检查价格是否在区间
    isRightPrice() {
      return +this.price >= this.minBargainPrice && +this.price <= this.originPrice
    },
    // 输入框宽度
    inputWidth() {
      return `${24 * String(this.price).length}px`
    }
  },
  mounted() {
    const img = new Image()
    img.src = this.bgImage
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.isInitializing = true // 开始初始化
          this.price = ''
          this.$nextTick(() => {
            this.showTouchTip = true
            // 在nextTick中设置滑块初始值，确保computed属性已计算完成
            this.sliderVal = Math.ceil((this.originPrice + this.minBargainPrice) / 2)

            // 延迟重置初始化标志，确保滑块设置完成
            this.$nextTick(() => {
              this.isInitializing = false
            })
          })
          // 当弹窗显示时获取代售费
          this.getServiceFee()
        }
      },
      immediate: true
    },
    // 监听price变化，同步滑块位置（仅当price是有效数字时）
    price(newVal) {
      // 只有当输入框有值且在有效范围内时才同步滑块
      // 避免初始化时的空值导致问题
      if (newVal !== '' && !isNaN(+newVal) && +newVal >= this.minBargainPrice && +newVal <= this.originPrice) {
        this.sliderVal = +newVal
      }
    }
  },
  methods: {
    // 获取代售费
    async getServiceFee() {
      try {
        this.isCheckingServiceFee = true
        const params = {
          action: {
            goodsPrice: 1, // 传入最小价格1，获取最低代售费
            gameId: this.bargainCheck?.gameId,
            goodsCatalogueId: this.bargainCheck?.goodsCatalogueId,
            goodsNo: this.goodsNo
          }
        }
        const res = await this.$api.getBargainFee(params)
        if (res.success) {
          this.serviceFee = res.data.serviceFee || 0
        }
      } catch (error) {
        console.error('获取代售费异常:', error)
      } finally {
        this.isCheckingServiceFee = false
      }
    },
    // 滑块变化
    onSliderChange(val) {
      // 如果正在初始化，不要设置输入框的值
      if (this.isInitializing) {
        return
      }

      this.showTouchTip = false
      this.price = val
    },
    // 禁止输入小数点
    onInput(e) {
      // 移除小数点及小数点后的内容
      const value = e.target.value.replace(/\./g, '')
      e.target.value = value
      // 如果输入为空，直接设置为空字符串，否则转换为数字
      this.price = value === '' ? '' : Number(value)
    },
    onSubmit: debounce(function() {
      if (+this.price < this.minBargainPrice) {
        this.$message.error(`报价须大于最低报价${this.minBargainPrice}元`)
        return
      } else if (+this.price > this.originPrice) {
        this.$message.error(`报价须小于商品原价${this.originPrice}元`)
        return
      }

      try {
        this.$emit('submit', Number(this.price))
      } catch (err) {
        console.error(err)
      }
    }),
    resetForm() {
      this.price = ''
      this.showTouchTip = true
      this.isInitializing = false // 重置初始化标志
      this.sliderVal = Math.ceil((this.originPrice + this.minBargainPrice) / 2) // 重置滑块到中间位置
    },
    handleDialogClosed() {
      this.resetForm()
    }
  }
}
